import React, { useState, useEffect } from "react";
import "./Header.css";
import logo from "./logo.png";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Determine active nav based on current path
  const getActiveNav = () => {
    const path = location.pathname;
    if (path === '/home') return 'home';
    if (path === '/book-ride') return 'book';
    if (path === '/blogs-gallery') return 'pricing';
    if (path === '/about-us') return 'about';
    if (path === '/contact') return 'contact';
    if (path === '/') return 'home'; // Handle root path
    return '';
  };

  const activeNav = getActiveNav();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        {/* Logo */}
        <a href="/">
          <div className="logo-container">
            <img src={logo} alt="Waheguru Cabs Logo" className="site-logo" />
            <span className="logo-text">
              <span className="logo-main">Waheguru</span>
              <span className="logo-sub">Cabs</span>
            </span>
          </div>
        </a>

        {/* Navigation */}
        <nav className={`nav-links ${mobileMenuOpen ? "mobile-open" : ""}`}>
          <ul>
            <li className={activeNav === "home" ? "active" : ""}>
              <a href="/home" onClick={handleNavClick}>
                Home
              </a>
            </li>
            <li className={activeNav === "book" ? "active" : ""}>
              <a href="/book-ride" onClick={handleNavClick}>
                Book Ride
              </a>
            </li>
            <li className={activeNav === "pricing" ? "active" : ""}>
              <a href="/blogs-gallery" onClick={handleNavClick}>
                Blogs/Gallery
              </a>
            </li>
            <li className={activeNav === "about" ? "active" : ""}>
              <a href="/about-us" onClick={handleNavClick}>
                About Us
              </a>
            </li>
            <li className={activeNav === "contact" ? "active" : ""}>
              <a href="/contact" onClick={handleNavClick}>
                Contact
              </a>
            </li>
          </ul>
        </nav>

        {/* Actions */}
        <div className="header-actions">
          <Link to="https://wa.me/+919765007100?text=Hi,%20I'm%20interested%20in%20booking%20a%20taxi%20or%20cab.%20Please%20provide%20details." target="_blank">
            <button className="book-now-btn-header">Book Now</button>
          </Link>
          <div
            className={`mobile-menu-btn ${mobileMenuOpen ? "open" : ""}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;